function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 text-white rounded-lg">

      <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800 leading-relaxed">
        
        {/* Image floated to the right */}
        <img
          src="/moses_chileshe.jpg"
          alt="CEO"
          className="float-right ml-6 mb-4 h-auto w-64 rounded-lg shadow-md object-cover"
        />

        {/* Header and intro text */}
        <h1 className="text-5xl font-extrabold text-white mb-4">
          NestQuest Technologies Limited
        </h1>
        <p className="text-3xl font-extrabold text-white mb-4 text-align-center">
          Pioneering Innovative Solutions for the Modern World
        </p>
        <p className="text-lg mb-4 text-white">
          NestQuest Technologies Limited is a trailblazing technology company founded by a quartet of visionary individuals: Chiko Mwiinga, Aubrey Chilambwe, and Moses Chileshe.
        </p>

        <p className="text-lg mb-4 text-slate-200">
          Certified on June 17<sup>th</sup>, 2025, NestQuest is driven by an unwavering passion for harnessing technology to solve real-world problems. Our flagship product, the NestQuest mobile application,
           is designed to revolutionize the rental property search experience, making it more efficient, secure, and user-friendly.
        </p>

        {/* Clear image float so next section starts clean */}
        <div className="clear-both pt-6">
          <p className="text-white">
            <b className="text-2xl">Core Values</b> <br></br>
            <li>
                Innovation: We cultivate a culture of creativity and innovation, constantly seeking new ways to improve our products and services.
            </li>
            <li>
                Integrity: We operate with unwavering transparency, honesty, and integrity, building trust with our users and partners.
            </li>
            <li>
                Customer-centricity: We prioritize user experience, ensuring that our solutions meet the evolving needs of our customers.
            </li>
            <li>
                Collaboration: We believe in the power of teamwork and partnerships, working together to achieve common goals and drive success.
            </li>

          </p>
          <br></br>
          <p className="text-white">
            <b className="text-2xl">What We Offer</b><br></br>
                Our NestQuest mobile application offers a range of features, including:
                <li>Property Listings: A comprehensive database of rental properties, complete with detailed information and photos.</li>
                <li>Advertisement Platform: Landlords can list their properties on the app for a fee, increasing their visibility and reach.</li>
                <li>Direct Contact: Users can reach out to our support team for inquiries or assistance directly through the app.</li>
                <li>Filtering Options: Advanced filters allow users to search for properties based on their preferences, streamlining the search process.</li>
                <li>Availability Notifications: The app indicates when a house has been rented, ensuring users have up-to-date information and reducing unnecessary searches.</li>
              </p>
          <div className="grid gap-3 md:grid-cols-2">

            {/* Mission */}
            <div className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition">
              <h2 className="text-xl font-semibold mb-3">Our Mission</h2>
              <p>
                At NestQuest, our mission is to empower individuals and families to find their ideal rental properties with ease, while providing landlords with a platform to showcase their 
                properties to a vast audience. We strive to build trust, foster growth, and create value through innovative technology solutions that exceed expectations.
              </p>
            </div>

            {/* Services */}
            <div className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition">
              <h2 className="text-xl font-semibold mb-3">What We Offer</h2>
              <p>
                Verified rental listings, landlord advertising, smart search filters, and a responsive support team to assist every step of the way.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
